import ssnBaseValidator from './ssn';

export default ssnBaseValidator;
